// SSO Callback - captures ?token= from backend redirect and establishes session
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const SSOCallbackPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { checkAuth } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const provider = params.get('provider') || 'SSO';

    if (!token) {
      setError('Missing authentication token from identity provider.');
      return;
    }

    (async () => {
      try {
        localStorage.setItem('access_token', token);
        localStorage.setItem('sso_provider', provider);
        await checkAuth();
        navigate('/dashboard', { replace: true });
      } catch (e) {
        setError('Session setup failed. Please try again.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#F3F4F6]"
      data-testid="sso-callback-page"
    >
      <div className="bg-white border border-[#E5E7EB] rounded-lg shadow-sm px-10 py-12 max-w-md w-full text-center">
        {!error ? (
          <>
            <div className="mx-auto mb-5 w-12 h-12 border-4 border-[#1B2A4A] border-t-transparent rounded-full animate-spin" />
            <h1 className="text-xl font-semibold text-[#1B2A4A] mb-2">
              Completing secure sign-in…
            </h1>
            <p className="text-sm text-[#6B7280]">
              Verifying your federal identity credentials.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold text-[#DC2626] mb-3" data-testid="sso-callback-error">
              Sign-in failed
            </h1>
            <p className="text-sm text-[#374151] mb-6">{error}</p>
            <button
              data-testid="sso-callback-return-btn"
              onClick={() => navigate('/login', { replace: true })}
              className="h-10 px-5 bg-[#1B2A4A] hover:bg-[#2D3F5F] text-white text-sm font-semibold rounded"
            >
              Return to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
};
